"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtraData = void 0;
const with_class_name_1 = require("./with-class-name");
class ExtraData extends with_class_name_1.WithClassName {
    constructor() {
        super(...arguments);
        this.offers = [];
        this.offerTags = [];
        this.vouchagramCoupons = [];
    }
}
exports.ExtraData = ExtraData;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/extra-data.js
// module id = 1219
// module chunks = 0